import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== SCSS ==========
import '../scss/footer.scss';

// ========== Font Awesome ==========
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// ========== ASSETS ==========
import backFooter from '../_assets/images/back_footer.png';
import doctor from '../_assets/images/icons/doctor.png';
import map from '../_assets/images/icons/map.png';
import people from '../_assets/images/icons/people.png';

export class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer style={{
        backgroundImage: 'url(' + backFooter + ')'
      }}>
        <div className="container">
          <div className="row">
            <div className="column">
              <a href="https://www.instagram.com/resp.socialhospitaloswaldocruz/" target="_blank" className="social">
                <FontAwesomeIcon icon={['fab', 'instagram']} />
              </a>
              <a href="https://www.linkedin.com/company/responsabilidade-social-haoc/" target="_blank" className="social">
                <FontAwesomeIcon icon={['fab', 'linkedin']} />
              </a>
              <a className="mail" rel="noopener noreferrer" target="_blank" href="mailto:regionalizacao@haoc.com.br">regionalizacao@haoc.com.br</a>
            </div>
            <div className="column">
              <a className="social" rel="noopener noreferrer" target="_blank" href="https://www.bp.org.br/institucional/impacto-social">
                <img src={people} /></a>
              <a className="social" rel="noopener noreferrer" target="_blank" href="https://www.bp.org.br/institucional/impacto-social/projetos-proadi-sus">
                <img src={doctor} /></a>
              <a className="social" rel="noopener noreferrer" target="_blank" href="https://www.bp.org.br/institucional/impacto-social/projetos-proadi-sus/regionalizacao">
                <img src={map} /></a>
              <a className="mail" rel="noopener noreferrer" target="_blank" href="mailto:regionalizacao@bp.org.br">regionalizacao@bp.org.br</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer
